export type Experiment = {
  key?: string;
  cohort?: string;
  tdfsExp?: string;
  data?: { [key: string]: any };
  dbKey?: string;
};

export enum FeedType {
  AFD = 0,
  RSOC = 1,
  YAHOO = 2,
  MESO = 3,
  ROLLER_ADS = 4,
  ROLLER_ADS_1CLICK = 5,
  ROLLER_ADS_1CLICK_387 = 6,
}

export type LanderConfig = {
  account: string;
  customerId: string;
  portfolioId: string;
  dataSource: string;
  displayType: string;
  rotatorId: string;
  system: string;
  domain?: {
    rootDomain: string;
    rootDomainDisplayText: string;
    rootDomainFromBrowser: string;
    expiresAt: string;
    expired: boolean;
    encryptedDomain: string;
    status: {
      internal: string;
    };
    isAdult: boolean;
    hasAuction: boolean;
    spins: string[];
  };
  adSense?: {
    channel: string;
    drid: string;
    pubId: string;
    keywords?: string[];
    keywordSource?: string;
  };
  experiment?: Experiment;
  lander?: {
    template: string;
    domainDisplayName: string;
    headerText: string;
    headerHtml: string;
    footerText: string;
    footerHtml: string;
    eventCallbackUrl: string;
    i18n: boolean;
    searchCount?: number;
    feedID?: FeedType;
    banner?: {
      show: boolean;
      type: string;
      link: string;
      text: string;
    };
    // flags
    showDomain: boolean;
  };
  // Intent-routing (PARKING-5157): when present, the lander redirects the
  // top window to this for-sale URL instead of rendering the parked page.
  intentRouting?: {
    redirectUrl: string;
  };
  // Intent-routing (PARKING-5158): experiment enrollment marker returned by the
  // CP API on both arms (as intentRouting.experimentId). Threaded onto every
  // lander event so exposure (treatment) and control renders are attributable.
  intentRoutingId?: string;
  // PARKING-5257: true when the request carried a recognized (non-TEMP)
  // customer login cookie. Not an authenticated-session guarantee; only the
  // boolean is surfaced, never the cookie value.
  hasCustomerLoginCookie?: boolean;
  rsoc?: {
    path?: string;
    url?: string;
  };
  yahoo?: {
    typeTag?: string;
  };
  rollerAds?: {
    keywords?: string[];
  };
  // Provider-agnostic high-value keywords semantically matched to the domain
  // (consumed by Yahoo Partner Supplied Terms today; other ad providers later).
  optimizedKeywords?: string[];
  // PARKING-5307: ParkWeb API's unified keywords. `source` is where the terms
  // came from ("llm" | "opensearch" | "findApi" | "tokenizer" | "domain");
  // `language` is the language the terms are in (e.g. "de", "pt-BR").
  keywords?: {
    terms: string[];
    source: string;
    language: string;
  };
  turnKeyReseller?: {
    displayName: string;
    programId: string;
    privateLabelId: string;
    privacyUrl: string;
    redirectUrl: string;
  };
};
